export default __webpack_public_path__ + "static/media/headerLogo.a20c30ae.svg";